module.exports = __webpack_public_path__ + "resources/img/page-bg.75600d0e.png";